import React, { useEffect } from 'react';
import {makeStyles, Theme} from "@material-ui/core";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';


const useStyles = makeStyles((theme: Theme) => ({
  modalOverlay: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100px', // Adjust height as needed
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(0, 0, 0, 0.0)', // Semi-transparent background
    zIndex: 9999,
  },
  modalContent: {
    background: theme.palette.primary.dark,
    padding: '20px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
  },
  modalBody: {
    display: 'flex',
    alignItems: 'center',
  },
  checkMarkIcon: {
    fontSize: '24px',
    color: theme.palette.primary.light,
    marginRight: '10px',
  },
  paragraph: {
    margin: 0,
    color: 'white',
  },
}));

const BottomModal = ({ isOpen, text, onClose }) => {
  const styles = useStyles();
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 10000); // 10 seconds

      return () => clearTimeout(timer); // Cleanup the timer on component unmount or when isOpen changes
    }
    return () => {};
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalBody}>
          <CheckCircleIcon className={styles.checkMarkIcon}/>
          <p className={styles.paragraph}>{text}</p>
        </div>
      </div>
    </div>
  );
};

export default BottomModal;
